<template>
  <div class="min-h-screen w-full flex flex-col md:flex-row">
    <div class="md:1/2 absolute-screen-image"></div>
    <div
      class="relative z-50 flex justify-center items-center mt-10 mx-auto py-8 px-6 text-center md:w-1/2"
    >
      <v-sheet
        class="mt-64 opacity"
        elevation="5"
        rounded="lg"
        max-width="500"
        width="90%"
        color="white"
      >
        <h3 class="mt-4 text-2xl font-semibold">Validación de cuenta</h3>

        <div class="text-center text-subtitle-3 font-weight-light mb-3">
          <h1 class="text-sm">
            Introduce el código de verificación que se envió al correo que
            registraste
          </h1>
        </div>

        <v-otp-input
          :loading="loading"
          class="mb-2"
          length="6"
          variant="underlined"
          v-model="otp"
        ></v-otp-input>

        <div>
          <v-btn
            :loading="validating"
            class="mt-2 bg-orange"
            rounded
            variant="plain"
            height="50"
            width="200"
            :style="{ opacity: '0.6' }"
            @click="onClick"
            :disabled="otp.length !== 6"
          >
            <h1 class="font-bold text-white">Validar código</h1>
          </v-btn>
        </div>

        <div class="text-caption">
          <v-btn
            color="red"
            size="xl-g"
            class="mb-6 mt-6 text-none"
            variant="text"
            opacity="0"
            height="60"
            @click="resetOtp"
            :disabled="newCode === 0"
          >
            <h1 class="text-sm font-bold">Enviar nuevo código</h1>
          </v-btn>
          <div
            v-if="otp.length !== 6 && newCode === 0"
            class="text-hint red--text text-align-center"
          >
            <h1>
              Has alcanzado el máximo de códigos enviados. Contacta a soporte
              para que puedas validar tu cuenta.
            </h1>
            <div>
              <a
                href="https://mail.google.com/mail/u/0/#inbox?compose=new&to=mts_official@gmail.com"
                class="email-link"
                :disabled="newCode === 0"
              >
                <v-btn
                  color="red"
                  height="30"
                  size="x-small"
                  class="mb-6 mt-6 text-none"
                  variant="text"
                  @click="resetOtp"
                >
                  <h1 class="text-aligh-center text-sm font-bold">
                    Contactar a MTS Official
                  </h1>
                </v-btn>
              </a>
            </div>
          </div>
        </div>
        <div v-if="otpError" class="text-hint red--text">
          {{ otpError }}
        </div>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import { apiFromBackend } from "@/helpers/ApiFromBackend"
import { toast } from "vue3-toastify"

export default {
  data: () => ({
    otp: "",
    validating: false,
    otpError: "",
    email: "",
    newCode: 5,
  }),
  methods: {
    async onClick() {
      if (this.otp.length > 0) {
        console.log(this.otp, this.email)
        console.log(localStorage.getItem("codigo_validacion"))
        this.validating = true
        try {
          const { data } = await apiFromBackend.post(
            "/api/cookie-cifra-validacion",
            {
              codigoUsuario: this.otp,
              correo: this.email,
              codigo_validacion: localStorage.getItem("codigo_validacion")
                ? localStorage.getItem("codigo_validacion")
                : "",
            },
          )
          console.log(data.mensaje)
          toast(data.mensaje, {
            hideProgressBar: true,
            autoClose: 600,
            type: "success",
            theme: "colored",
            onClose: () => {
              this.$router.push({ name: "login" })
            },
          })
          this.newCode--
        } catch (response) {
          toast(response.response.data.mensaje, {
            hideProgressBar: true,
            autoClose: 1500,
            type: "error",
            theme: "colored",
          })
        } finally {
          this.validating = false
        }
      }
    },
    async resetOtp() {
      if (this.newCode > 0) {
        this.otp = ""
        this.otpError = ""
        try {
          const { data } = await apiFromBackend.post(
            "/api/cookie-cifra-creacion",
            {
              correo: this.email,
            },
          )
          toast(data.mensaje, {
            hideProgressBar: true,
            autoClose: 600,
            type: "success",
            theme: "colored",
          })
        } catch (response) {
          toast(response.response.data.mensaje, {
            hideProgressBar: true,
            autoClose: 1500,
            type: "error",
            theme: "colored",
          })
        }
        this.newCode--
      }
    },
  },
  mounted() {
    this.email = this.$route.query.email
  },
}
</script>

<style scoped>
.absolute-screen-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("@/assets/images/imagen009.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}
</style>
